exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".buttons[data-v-53ca80ec]{float:right;padding:0 30px 30px 0}", "", {"version":3,"sources":["/workspace/src/views/invoice-apply/components/InvoiceVoidDialog.vue"],"names":[],"mappings":"AACA,0BAA0B,YAAY,qBAAqB,CAC1D","file":"InvoiceVoidDialog.vue","sourcesContent":["\n.buttons[data-v-53ca80ec]{float:right;padding:0 30px 30px 0\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-53ca80ec","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/invoice-apply/components/InvoiceVoidDialog.vue
// module id = 4370
// module chunks = 109